import React from 'react';
import { X } from 'lucide-react';

type HeaderControlsProps = {
  onExit: () => void;
  dispatch: React.Dispatch<{ type: string; payload?: any }>;
};

export const PracticeTestHeaderControls: React.FC<HeaderControlsProps> = ({
  onExit,
}) => {
  return (
    <div className="practice-header-controls-wrap">
      <button
        type="button"
        onClick={onExit}
        aria-label="Close test and return to dashboard"
        className="header-control-icon-box header-control-btn"
      >
        <X size={20} strokeWidth={2.4} color="#FFFFFF" />
      </button>
    </div>
  );
};
